import React, { useEffect, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { Field, FullLoader, Label } from './styles';
import cleanTitle from '../../../utils/cleanTitle';
import { smallDateFormat } from '../../../utils/Utils';
import { producaov2 } from '../../../services/apis';

export default function OrderDetailsModal({ isOpen, selectedEnvio, onClose }) {
  const [loadDataPedido, setLoadDataPedido] = useState(true);
  const [dataPedidoSelecionado, setDataPedidoSelecionado] = useState({});
  const [tipoVerificadoModal, setTipoVerificadoModal] = useState();
  
  useEffect(() => {
    const getPedido = async ({ orderID, type }) => {
      setLoadDataPedido(true);
      setTipoVerificadoModal(type === "material" ? 1 : 0)
      try {
        const data_pedido = await producaov2.get(`admin/pedido/envios/dados-pedido/${orderID}`);
  
        if (data_pedido.data) {
          setDataPedidoSelecionado(data_pedido?.data?.pessoaCurso);
          setLoadDataPedido(false);
          return;
        }
  
      } catch (error) {
        swal("Erro nos dados:", "Consultar dados de pedido do usuário e chamar o time de TI", "warning")
      }
    };

    getPedido({ orderID: selectedEnvio?.orderID, type: selectedEnvio?.type || selectedEnvio?.tipo });
  }, [selectedEnvio]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size="small"
      style={{
        maxHeight: "80vh",
        overflowY: "scroll"
      }}
    >
      <Modal.Header>Dados do Pedido</Modal.Header>

      {
        loadDataPedido ? (
          <Modal.Content>
            <div style={{
              width: "100%",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              {/* <Loader active inline="centered" size="small" /> */}
              <FullLoader />
            </div>
          </Modal.Content>
        ) : (
          <Modal.Content>
            <Field style={{ marginTop: 0, paddingTop: 0 }}>
              <Label>Nome:</Label>
              <p>{dataPedidoSelecionado?.pessoa?.nome || "Não encontrado"}</p>
            </Field>

            <Field>
              <Label>Email:</Label>
              <p>{dataPedidoSelecionado?.pessoa?.email}</p>
            </Field>

            <Field>
              <Label>CPF:</Label>
              <p>{dataPedidoSelecionado?.pessoa?.cpf}</p>
            </Field>

            <Field>
              <Label>Endereço:</Label>
              <p>
                Rua: {dataPedidoSelecionado?.pessoa?.endereco}<br/>
                Número: {dataPedidoSelecionado?.pessoa?.numero}<br/>
                Bairro: {dataPedidoSelecionado?.pessoa?.bairro}<br/>
                Cidade: {dataPedidoSelecionado?.pessoa?.cidade}<br/>
                Estado: {dataPedidoSelecionado?.pessoa?.estado}<br/>
                Cep: {dataPedidoSelecionado?.pessoa?.cep}<br/>
                Complemento: {dataPedidoSelecionado?.pessoa?.complemento || "Sem complemento"}

              </p>
            </Field>

            <Field>
              <Label>Celular:</Label>
              <p>{dataPedidoSelecionado?.pessoa?.celular}</p>
            </Field>

            <Field>
              <Label>Curso Comprado:</Label>
              <p>{cleanTitle(dataPedidoSelecionado?.curso_comprado)}</p>
            </Field>

            <Field>
              <Label>Valor Pago:</Label>
              <p>R$ {dataPedidoSelecionado?.valor_pago}</p>
            </Field>

            <Field>
              <Label>Status do Pedido:</Label>
              <p>{dataPedidoSelecionado?.status_pedido == 3 ? "Pago" : [0, 1, 2, 4].includes(Number(dataPedidoSelecionado?.status)) ? "Pendente" : "Estorno"}</p>
            </Field>

            <Field>
              <Label>Data de Pagamento:</Label>
              <p>{smallDateFormat(dataPedidoSelecionado?.data_pagamento)}</p>
            </Field>

            {tipoVerificadoModal === 1 && dataPedidoSelecionado?.solicitacao?.material?.length > 0 && (
              <Field>
                <Label>Solicitação de Materiais:</Label>
                {dataPedidoSelecionado?.solicitacao?.material ?
                  dataPedidoSelecionado?.solicitacao?.material.map((material, index) => (
                    <p key={index}>{cleanTitle(material?.curso)} - [{material?.id_curso}]</p>
                  )) : "Não foi solicitado materiais"}
              </Field>
            )}

            {tipoVerificadoModal === 0 && dataPedidoSelecionado?.solicitacao?.certificado?.length > 0 && (
              <Field>
                <Label>Solicitação de Certificados:</Label>
                {dataPedidoSelecionado?.solicitacao?.certificado ? dataPedidoSelecionado?.solicitacao?.certificado.map((certificado, index) => (
                  <p key={index}>
                    <p>{cleanTitle(certificado?.curso)} - [{certificado?.id_curso}]</p>
                    <a href={certificado?.certificado_gerado} target="_blank" rel="noopener noreferrer">
                      Ver Certificado
                    </a>
                  </p>
                )) : "Não foi solicitado certificado"}
              </Field>
            )}
          </Modal.Content>
        )
      }
    </Modal>
  )
}